$(document).ready(function(){
  
$(".hulk-powered-wrapper").remove();
    // Make Menu Items Active
    $(function () {
        var current = location.pathname;
        $('.footer-menu ul li a').each(function () {
            var $this = $(this);
            if ($this.attr('href') == current) {
                $this.addClass('active');
            }
        })
    });

    $('.hero-slider').owlCarousel({
       loop:true,
       autoplay: true,
       autoplayTimeout: 5000,
       autoplaySpeed: 1000,
        responsive:{
            0:{
                items:1,
                nav:false,
                dots: false
            },
            600:{
                items:1,
                nav:false,
                dots: false
            },
            1000:{
                items:1,
                nav:false,
                dots: false
            }
        }
    });

    $('.cat-owl').owlCarousel({
        loop:false,
        margin:25,
        responsive:{
            0:{
                items:1,
                nav:true,
                dots: false
            },
            600:{
                items:2,
                nav:true,
                dots: false
            },
            1000:{
                items:3,
                nav:false,
                dots: false
            }
        }
    });
  
        $('.story-dropwodn-wrapper > button:first-child').addClass('drop-active');
        $(document).find('#storyDetails .story-title').text( jQuery('.story-dropwodn-wrapper > button:first-child').data('title') );
        $(document).find('#storyDetails .story-content > p').html( jQuery('.story-dropwodn-wrapper > button:first-child').data('details') );
        $(document).find('#storyDetails .reviewer-details h6').text( jQuery('.story-dropwodn-wrapper > button:first-child').data('reviewer') );
        $(document).find('#storyDetails .reviewer-details p').text( jQuery('.story-dropwodn-wrapper > button:first-child').data('reviewermeta') );
        $(document).find('#storyDetails .story-reviewer-img img').attr('src', jQuery('.story-dropwodn-wrapper > button:first-child').data('reviewer-img') );
  
      $(document).on('click', '.story-dropdown', function(e){
        e.preventDefault();
      
        $(document).find('#storyDetails .story-title').text( jQuery(this).data('title') );
        $(document).find('#storyDetails .story-content > p').html( jQuery(this).data('details') );
        $(document).find('#storyDetails .reviewer-details h6').text( jQuery(this).data('reviewer') );
        $(document).find('#storyDetails .reviewer-details p').text( jQuery(this).data('reviewermeta') );
        $(document).find('.section-story .story-reviewer-img img').attr('src', jQuery(this).data('reviewer-img') );
        $('.story-dropdown').removeClass('drop-active');
        $(this).addClass('drop-active');
        
        
    });

    if( window.location.href.indexOf('?v=1') > -1 )
    {
      setTimeout( function(){ $('.story-dropwodn-wrapper > button:nth-child(1)').trigger('click'); }, 500 );
    }
    if( window.location.href.indexOf('?v=2') > -1 )
    {
      setTimeout( function(){ $('.story-dropwodn-wrapper > button:nth-child(2)').trigger('click'); }, 500 );
    }
    if( window.location.href.indexOf('?v=3') > -1 )
    {
      setTimeout( function(){ $('.story-dropwodn-wrapper > button:nth-child(3)').trigger('click'); }, 500 );
    }
    if( window.location.href.indexOf('?v=4') > -1 )
    {
      setTimeout( function(){ $('.story-dropwodn-wrapper > button:nth-child(4)').trigger('click'); }, 500 );
    }
  
// Share / FAQ story form popup (HulkApps pxFormGenerator inside #share-story-popup)
  function openShareStoryPopup(e) {
    if (e) e.preventDefault();
    if (!window.jQuery || !jQuery.magnificPopup) return;
    // Prefer dedicated popup; on tell-your-story page scroll to inline form instead
    if (jQuery('#share-story-form').length && jQuery('#share-story-form .pxFormGenerator').length) {
      var $t = jQuery('#share-story-form');
      jQuery('html, body').animate({ scrollTop: $t.offset().top - 80 }, 400);
      return;
    }
    if (jQuery('#share-story-popup').length) {
      jQuery.magnificPopup.open({
        items: { src: '#share-story-popup' },
        type: 'inline',
        midClick: true,
        closeOnBgClick: true
      });
    }
  }
  $(document).on('click', '.share-pop-btn a, .faq-btn a', openShareStoryPopup);

  // HulkApps Discount Form popup (restored classic timed open)
  (function(){
    try {
      if (window.hulkFormBuilder && window.hulkFormBuilder.form_data && window.hulkFormBuilder.form_data['form_3NW9qQSAbwwHwJRAgIawEw']) {
        window.hulkFormBuilder.form_data['form_3NW9qQSAbwwHwJRAgIawEw'].form_is_active = true;
      }
    } catch (err) {}
    var firstPopupTime = localStorage.getItem('im_discount_popup_time');
    var currentTime = new Date().getTime();
    var cooldown = 24 * 60 * 60 * 1000; // once per day
    if ($.cookie && $.cookie('user_subscribed') == 200) return;
    if (!firstPopupTime || (currentTime - Number(firstPopupTime)) >= cooldown) {
      setTimeout(function() {
        if (!$('#discount-popup').length || !$.magnificPopup) return;
        // Ensure Discount Form renders even if app still has form_is_active:false
        try {
          if (window.hulkFormBuilder && window.hulkFormBuilder.form_data && window.hulkFormBuilder.form_data['form_3NW9qQSAbwwHwJRAgIawEw']) {
            window.hulkFormBuilder.form_data['form_3NW9qQSAbwwHwJRAgIawEw'].form_is_active = true;
          }
        } catch (err) {}
        try {
          var root = window.hulkFormBuilder && window.hulkFormBuilder.form_data && window.hulkFormBuilder.form_data['form_3NW9qQSAbwwHwJRAgIawEw'];
          if (root) {
            root.form_is_active = true;
            if (root.form_data) {
              root.form_data.form_title = '<h3 style="text-align: center;">Stay close to the movement</h3>\n';
              root.form_data.form_description = '<p style="text-align: center;">New CancerCulture® drops, survivor stories, and what\u2019s coming next.</p>\n<p class="im-welcome-line" style="text-align: center;">A 10% off welcome offer lands in your inbox when you join.</p>\n';
              root.form_data.form_submit = 'Sign up';
            }
          }
        } catch (err) {}
        var $host = $('#discount-popup .pxFormGenerator');
        if ($host.length && !$host.find('iframe').length && $host.children().length === 0) {
          var ref = encodeURIComponent(window.location.href);
          $host.html('<iframe title="Newsletter signup" id="frame_3NW9qQSAbwwHwJRAgIawEw" src="https://formbuilder.hulkapps.com/corepage/customform?id=3NW9qQSAbwwHwJRAgIawEw&referrer_url=' + ref + '" style="width:100%;min-height:420px;border:0;"></iframe>');
        } else if ($host.length && !$host.find('iframe').length) {
          var $h3 = $host.find('h3').first();
          if ($h3.length && /10%|next purchase|Join CancerCulture/i.test($h3.text())) {
            $h3.text('Stay close to the movement');
          }
          $host.find('p, strong').each(function () {
            if (/^Sign Up Now$/i.test($.trim($(this).text()))) {
              $(this).text('New CancerCulture® drops, survivor stories, and what’s coming next.');
            }
          });
          $host.find('button, input[type="submit"]').each(function () {
            if (this.tagName === 'INPUT' && /^Sign Up$/i.test(this.value || '')) this.value = 'Sign up';
            else if (/^Sign Up$/i.test($.trim($(this).text()))) $(this).text('Sign up');
          });
          if ($host.length && $host.children().length > 0 && $host.text().indexOf('A 10% off welcome offer lands in your inbox when you join.') === -1) {
            $host.append('<p class="im-signup-welcome-offer im-welcome-line">A 10% off welcome offer lands in your inbox when you join.</p>');
          }
        }
        $.magnificPopup.open({
          items: { src: '#discount-popup' },
          type: 'inline',
          midClick: true,
          closeOnBgClick: true
        });
        localStorage.setItem('im_discount_popup_time', String(currentTime));
      }, 2500);
    }
  })();

  // Force-open helper for QA: /?im_discount=1
  if (window.location.search.indexOf('im_discount=1') > -1) {
    setTimeout(function(){
      localStorage.removeItem('im_discount_popup_time');
      if ($('#discount-popup').length && $.magnificPopup) {
        try {
          var root = window.hulkFormBuilder && window.hulkFormBuilder.form_data && window.hulkFormBuilder.form_data['form_3NW9qQSAbwwHwJRAgIawEw'];
          if (root) {
            root.form_is_active = true;
            if (root.form_data) {
              root.form_data.form_title = '<h3 style="text-align: center;">Stay close to the movement</h3>\n';
              root.form_data.form_description = '<p style="text-align: center;">New CancerCulture® drops, survivor stories, and what\u2019s coming next.</p>\n<p class="im-welcome-line" style="text-align: center;">A 10% off welcome offer lands in your inbox when you join.</p>\n';
              root.form_data.form_submit = 'Sign up';
            }
          }
        } catch (err) {}
        var $host = $('#discount-popup .pxFormGenerator');
        if ($host.length && !$host.find('iframe').length && $host.children().length === 0) {
          var ref = encodeURIComponent(window.location.href);
          $host.html('<iframe title="Newsletter signup" id="frame_3NW9qQSAbwwHwJRAgIawEw" src="https://formbuilder.hulkapps.com/corepage/customform?id=3NW9qQSAbwwHwJRAgIawEw&referrer_url=' + ref + '" style="width:100%;min-height:420px;border:0;"></iframe>');
        } else if ($host.length && !$host.find('iframe').length) {
          var $h3 = $host.find('h3').first();
          if ($h3.length && /10%|next purchase|Join CancerCulture/i.test($h3.text())) {
            $h3.text('Stay close to the movement');
          }
          $host.find('p, strong').each(function () {
            if (/^Sign Up Now$/i.test($.trim($(this).text()))) {
              $(this).text('New CancerCulture® drops, survivor stories, and what’s coming next.');
            }
          });
          $host.find('button, input[type="submit"]').each(function () {
            if (this.tagName === 'INPUT' && /^Sign Up$/i.test(this.value || '')) this.value = 'Sign up';
            else if (/^Sign Up$/i.test($.trim($(this).text()))) $(this).text('Sign up');
          });
          if ($host.length && $host.children().length > 0 && $host.text().indexOf('A 10% off welcome offer lands in your inbox when you join.') === -1) {
            $host.append('<p class="im-signup-welcome-offer im-welcome-line">A 10% off welcome offer lands in your inbox when you join.</p>');
          }
        }
        $.magnificPopup.open({ items: { src: '#discount-popup' }, type: 'inline', midClick: true, closeOnBgClick: true });
      }
    }, 1200);
  }




$('.accordion-wrap').first().addClass('active');
$('.accordion-panel').first().addClass('active').css('max-height', $('.accordion-panel').first().prop('scrollHeight') + 'px');  
$(document).on('click', '.accordion-btn', function(e){
    e.preventDefault();

$(document).find('.section-faq .accordian-img img').attr('src', jQuery(this).data('reviewer-img') );
     var panel = $(this).next('.accordion-panel');
    var isActive = panel.hasClass('active');

    $('.accordion-wrap').removeClass('active');
    $('.accordion-panel').css('max-height', '0').removeClass('active');

    if (!isActive) {
        panel.addClass('active').css('max-height', panel.prop('scrollHeight') + 'px');
        $(this).closest('.accordion-wrap').addClass('active');
    }
});

    // $('.lazy').Lazy({
    //     scrollDirection: 'vertical',
    //     effect: 'fadeIn',
    //     visibleOnly: true,
    //     onError: function(element) {
    //         console.log('error loading ' + element.data('src'));
    //     }
    // });

  let current = location.pathname;
  var pathName = window.location.pathname;
  var collectionsPart = pathName.substring(pathName.indexOf('/collections/') + '/collections/'.length, pathName.indexOf('/', pathName.indexOf('/collections/') + '/collections/'.length));
  var collectionsPart2 = pathName.substring(pathName.indexOf('/collections') + '/collections'.length, pathName.indexOf('/', pathName.indexOf('/collections') + '/collections'.length));
  
  setTimeout(function(){
    if( $('#im-signup-popup').length ){ return false; } /* native popup active: skip legacy wrapper */
    if( $.cookie('user_subscribed') == 200 ){ return false; }
    if( current == '/challenge' ){ return false; }

    if( collectionsPart == '/collections/' )
    {
        $(document).find('.custom-signup-popup-wrapper').removeClass( 'hide-popup' );
        $(document).find('body').addClass( 'body-popup-no-overflow' );
    }
    else if( collectionsPart2 == '/collections' )
    {
        $(document).find('.custom-signup-popup-wrapper').removeClass( 'hide-popup' );
        $(document).find('body').addClass( 'body-popup-no-overflow' );
    }
    else
    {
        return false;
    }
    
    // $(document).find('.custom-signup-popup-wrapper').removeClass( 'hide-popup' );
    // $(document).find('body').addClass( 'body-popup-no-overflow' );
  }, 7000);

  $(document).on('click', '.pop-close', function(){
    $.cookie('user_subscribed', 200, { expires: 3650 });
    $(this).parent().parent().addClass( 'hide-popup' );
    $(document).find('body').removeClass( 'body-popup-no-overflow' );
  });
  
  if( window.location.href.indexOf('?customer_posted=true') > -1 )
  {
    $.cookie('user_subscribed', 200, { expires: 3650 });
    if( $('#im-signup-popup').length ){ return; } /* native popup shows its own thank-you */
    
    $(document).find('.custom-signup-popup-wrapper').removeClass( 'hide-popup' );
    $(document).find('body').addClass( 'body-popup-no-overflow' );
    let newHTML = '<div class="discount-code"><h2>Welcome to the movement. A welcome offer is on its way — check your inbox.</h2></div>';
    $(document).find('.signup-wrapper').html(newHTML);
  }

});


jQuery( document ).ready(function() {
    if (window.location.href == "https://infinitemotiv.com/pages/unite-the-fight") {
       jQuery('body').addClass('unite-fight-page');
    }
});